import React from 'react';
import Sidebar from '../../components/SideNavBar/SideNavBar';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CategoryIcon from '@mui/icons-material/Category';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PaymentIcon from '@mui/icons-material/Payment';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useAuth } from '../../contexts/AuthContext';

const ALL_SECTIONS = [
    {
        heading: 'Operations',
        items: [
            { text: 'Order Management', icon: <NotificationsIcon />, path: '/order-management', permissions: ['orders.manage', 'orders.view'] },
            { text: 'Payment Requests', icon: <PaymentIcon />, path: '/payment-requests', permissions: ['payments.manage', 'payments.verify'] },
            { text: 'Customer Management', icon: <PeopleIcon />, path: '/customer-management', permissions: ['customers.manage', 'customers.view'] },
            { text: 'Vendor Management', icon: <StorefrontIcon />, path: '/vendor-management', permissions: ['vendors.manage'] },
        ],
    },
    {
        heading: 'Catalog',
        items: [
            { text: 'Product Management', icon: <ShoppingCartIcon />, path: '/product-management', permissions: ['products.manage'] },
            { text: 'Upload Product', icon: <CloudUploadIcon />, path: '/upload-product', permissions: ['products.manage'] },
            { text: 'Category Management', icon: <CategoryIcon />, path: '/category-management', permissions: ['categories.manage'] },
            { text: 'MFR Management', icon: <BusinessIcon />, path: '/mfr-management', permissions: ['manufacturers.manage'] },
        ],
    },
    {
        heading: 'Administration',
        items: [
            { text: 'User Management', icon: <ManageAccountsIcon />, path: '/user-management', permissions: ['users.manage'] },
            { text: 'Role Management', icon: <AdminPanelSettingsIcon />, path: '/role-management', permissions: ['roles.manage'] },
        ],
    },
];

const AdminPortalSideBar = () => {
    const { hasPermission } = useAuth();

    const visibleSections = ALL_SECTIONS
        .map(section => ({
            heading: section.heading,
            items: section.items.filter(item =>
                item.permissions.some(p => hasPermission(p))
            ),
        }))
        .filter(section => section.items.length > 0);

    return <Sidebar sections={visibleSections} />;
};

export default AdminPortalSideBar;
